/**
 * DelayedFallback
 *
 * Suspense fallback wrapper that renders nothing for the first `delayMs`.
 * If Suspense resolves quickly (fast networks, warmed chunks), users never
 * see a loader flash. If it takes longer, the real fallback fades in.
 */
import React, { useEffect, useState } from "react";

interface Props {
  delayMs?: number;
  children: React.ReactNode;
}

const DelayedFallback: React.FC<Props> = ({ delayMs = 150, children }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const id = window.setTimeout(() => setShow(true), delayMs);
    return () => window.clearTimeout(id);
  }, [delayMs]);

  if (!show) return null;
  return (
    <div style={{ animation: "rr-fade-in 180ms ease-out both" }}>
      {children}
    </div>
  );
};

export default DelayedFallback;
